<template>
  <v-container>
    <v-row class="my-n8">
      <v-col>
        <v-checkbox
          v-model="blue"
          label="ON"
          color="primary"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          v-model="grey"
          label="OFF"
          color="grey"
          hide-details
        ></v-checkbox>
      </v-col>  
    </v-row>
    <v-row>
      <v-col>
        <v-card>
        <l-map
          v-if="showMap"
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          style="height: 80vH"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate"
        >
          <l-tile-layer
            :url="url"
          />
          <span v-for="item in devices" :key="item.station">
          <span v-if="item.condition === 'ON' && blue">
            <l-marker 
              :lat-lng="item.map"
              :icon="item.icon"
              >
              <l-popup>
                <div>
                  {{item.station}} <br> {{item.location}}
                  <p>
                    last update: {{updateTime(item.time)}}
                  </p>
                </div>
              </l-popup>
            </l-marker>
          </span>
          <span v-if="grey && item.condition!=='ON'">
            <l-marker 
              :lat-lng="item.map"
              :icon="item.icon"
              >
              <l-popup>
                <div>
                  {{item.station}} <br> {{item.location}}
                  <p>
                    last update: {{updateTime(item.time)}}
                  </p>
                </div>
              </l-popup>
            </l-marker>
          </span>
          </span>
        </l-map>
        </v-card>
        <!-- <span v-if="role==='Administrator'" >
          <v-row class="text-center">
            <v-col>
              <v-btn class= "my-2" color="primary" @click="geoJSONButton()">
                Download KMZ
              </v-btn>
            </v-col>
          </v-row>
        </span> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db }from "../firebase/db.js"
// import moment from 'moment'
import { latLng, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup,  } from "vue2-leaflet";

import { Icon } from 'leaflet';

import GeoJSON from 'geojson'
import tokml from "geojson-to-kml";
import JSZip from 'jszip'
import { saveAs } from 'file-saver';
import moment from 'moment'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      blue:true,
      grey:true,
      role: null,
      zoom: 8,
      center: latLng(-6.87, 107.579),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      Rlatlng: latLng(-6.87, 107.579),
      latlng: [],
      devices:[],
      infoTime:[],
      mapOptions: {
        zoomSnap: 0.5
      },
      GPS:[],
      conditions:[],
      showMap: true,
      closeButton: false,
      geoData:[],
      recapData:[],
      Bicon: icon({
        iconRetinaUrl: require('@/assets/Map/BSphere.png'),
        iconUrl: require('@/assets/Map/BSphere.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      Yicon: icon({
        iconRetinaUrl: require('@/assets/Map/YSphere.png'),
        iconUrl: require('@/assets/Map/YSphere.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
    };
  },
  async mounted () {
    const date=new Date();
    this.offset=date.getTimezoneOffset()/(-60)
    let loader = this.$loading.show()
    this.role = localStorage.getItem("role")
    if (localStorage.getItem('role')== null) {
      this.$router.push('login')
    }
    if (localStorage.getItem('role')!= 'Administrator') {
      this.$router.replace('/')
    }
    if (localStorage.getItem("role")=='Petugas') {
      let device = localStorage.getItem('device')
      this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
    }
    var deviceRef= db.collection('device')
    var GPSRef = db.collection('GPS')
    deviceRef.onSnapshot((collectionSnapshot) => { 
      GPSRef.onSnapshot((collections) => {
        this.GPS=[]
        collections.forEach((doc) => {
          this.GPS.push({id:doc.id,...doc.data()})
        })
        let index=0;
        this.devices=[]
        collectionSnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              index = this.GPS.findIndex(x => x.id === doc.id);
              if (index!=-1) {
                if (this.GPS[index].condition==='ON') {
                  this.devices.push({icon: this.Bicon, station: doc.data().station, map:latLng(parseFloat(this.GPS[index].lat),parseFloat(this.GPS[index].lng)), location:doc.data().location, time:this.GPS[index].time, condition:this.GPS[index].condition}) 
                } else {
                  this.devices.push({icon: this.Yicon, station: doc.data().station, map:latLng(parseFloat(this.GPS[index].lat),parseFloat(this.GPS[index].lng)), location:doc.data().location, time:this.GPS[index].time, condition:this.GPS[index].condition}) 
                }
              }
            }
          } else {
            index = this.GPS.findIndex(x => x.id === doc.id);
            if (index!=-1) {
              if (this.GPS[index].condition==='ON') {
                this.devices.push({icon: this.Bicon, station: doc.data().station, map:latLng(parseFloat(this.GPS[index].lat),parseFloat(this.GPS[index].lng)), location:doc.data().location, time:this.GPS[index].time, condition:this.GPS[index].condition}) 
              } else {
                this.devices.push({icon: this.Yicon, station: doc.data().station, map:latLng(parseFloat(this.GPS[index].lat),parseFloat(this.GPS[index].lng)), location:doc.data().location, time:this.GPS[index].time, condition:this.GPS[index].condition}) 
              }
            }
          }
        })
      })
      loader.hide()
    })
  },
  methods: {
    updateTime (time) {
      return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    closeButtons () {
      console.log("HELLO")
    },
    geoJSONButton () {
      var zip = new JSZip();
      zip.file("devices.kml", tokml(GeoJSON.parse(this.geoData, {Point: ['lat','lng']})));

      zip.generateAsync({type:"blob"}).then(function(content) {
          // see FileSaver.js
          console.log("KMZ Exported")
          saveAs(content, "devices.kmz");
      }).catch(err => { 
        console.log (err)
      });
    }
  }
};
</script>

<style lang="scss">
  .vue2leaflet-map {
    z-index: 1;
  }
</style>
